import type { ComponentType } from 'react'
import { NavLink } from 'react-router'
import { BookmarkIcon, TrophyIcon, HomeIcon, ListIcon, MoreIcon } from './icons'
import styles from './MainNav.module.css'

/** reloadDocument: a server-rendered page outside the app (e.g. /news). */
export interface NavItem { to: string; label: string; end?: boolean; reloadDocument?: boolean }

export const PRIMARY_NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/ranked', label: 'Ranked' },
  { to: '/announcements', label: 'Announcements' },
  { to: '/calendar', label: 'Calendar' },
  { to: '/news', label: 'News', reloadDocument: true },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/alerts', label: 'Alerts' },
]

/** Desktop header navigation (active item: navy text + 2px underline). */
export function MainNav({ items = PRIMARY_NAV, label = 'Main' }: { items?: NavItem[]; label?: string }) {
  return (
    <nav aria-label={label} className={styles.nav}>
      {items.map(i => (
        <NavLink key={i.to} to={i.to} end={i.end} reloadDocument={i.reloadDocument} className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}>
          {i.label}
        </NavLink>
      ))}
    </nav>
  )
}

interface BottomItem { to: string; label: string; icon: ComponentType<{ size?: number }>; end?: boolean }

const BOTTOM: BottomItem[] = [
  { to: '/', label: 'Home', icon: HomeIcon, end: true },
  { to: '/watchlist', label: 'Watchlist', icon: BookmarkIcon },
  { to: '/announcements', label: 'Filings', icon: ListIcon },
  { to: '/ranked', label: 'Ranked', icon: TrophyIcon },
  { to: '/more', label: 'More', icon: MoreIcon },
]

/** Phone (≤480px) bottom navigation, 64px, 44px+ touch targets. */
export function BottomNav() {
  return (
    <nav aria-label="Main (mobile)" className={styles.bottom}>
      {BOTTOM.map(({ to, label, icon: Icon, end }) => (
        <NavLink key={to} to={to} end={end} className={({ isActive }) => `${styles.bottomLink} ${isActive ? styles.bottomActive : ''}`}>
          <Icon size={21} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
